import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from '@redturtle/iovisit-theme/components/Blocks/CountDown/Sidebar';
import Body from '@redturtle/iovisit-theme/components/Blocks/CountDown/Body';

const Edit = (props) => {
  const { data, selected } = props;

  return (
    <>
      <Body data={data} />
      <SidebarPortal selected={selected}>
        <Sidebar {...props} />
      </SidebarPortal>
    </>
  );
};

export default Edit;
